module.exports = __webpack_public_path__ + "img/submitComment.af970299.svg";